<template>
  <div v-for="(compilation, index) in value" :key="'compilation' + index">
    <CompilationWidget
      type="list"
      :value="compilation"
      :loading="!compilation"
      hide-empty
      :grid="gridSize"
    >
      <template #empty><div /></template>
    </CompilationWidget>
    <UiHorizontalRule />
  </div>
</template>

<script setup lang="ts">
import { type Compilation } from '@/5_entities/Compilation'
import { useCompilationGrid } from '@/5_entities/Compilation'
import { UiHorizontalRule } from '@/6_shared/ui'
import CompilationWidget from './CompilationWidget/CompilationWidget.vue'

type PropType = {
  value: Compilation[] | undefined[]
  loading: boolean
}

defineProps<PropType>()
const { gridSize } = useCompilationGrid()
</script>
